import { render, staticRenderFns } from "./DirectorEmployeeView.vue?vue&type=template&id=72807652&scoped=true&"
import script from "./DirectorEmployeeView.vue?vue&type=script&lang=js&"
export * from "./DirectorEmployeeView.vue?vue&type=script&lang=js&"
import style0 from "./DirectorEmployeeView.vue?vue&type=style&index=0&id=72807652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72807652",
  null
  
)

export default component.exports